import { apiSlice } from "../api/apiSlice";

export const quizzeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => "/quizzes",
    }),
    addQuiz: builder.mutation({
      query: (body) => ({
        url: "/quizzes",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (res.data) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getQuizzes",
                undefined,
                (draft) => {
                  draft.push(res.data);
                }
              )
            );
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
    deleteQuiz: builder.mutation({
      query: (id) => ({
        url: `/quizzes/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
            return draft.filter((item) => item.id !== id);
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
    editQuiz: builder.mutation({
      query: (body) => ({
        url: `/quizzes/${body.id}`,
        method: "PATCH",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;

        if (response?.data?.id) {
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              let indexToUpdate = draft.findIndex(
                (task) => task.id == arg.id.toString()
              );
              if (indexToUpdate !== -1) {
                draft[indexToUpdate] = response.data;
              }
            })
          );

          dispatch(
            apiSlice.util.updateQueryData(
              "getVideo",
              arg.id.toString(),
              (draft) => {
                Object.assign(draft, response.data);
              }
            )
          );
        }
      },
    }),
    getQuiz: builder.query({
      query: (id) => `/quizzes/${id}`,
    }),
  }),
});

export const {
  useGetQuizzesQuery,
  useAddQuizMutation,
  useDeleteQuizMutation,
  useEditQuizMutation,
  useGetQuizQuery,
} = quizzeApi;
